(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Mudou a quantidade, o formulário vai sozinho. O botao "Atualizar" some
  // porque com o envio automatico ele passa a ser uma etapa a mais para fazer
  // o que ja aconteceu — mas ele existe no HTML, e sem script continua sendo
  // o unico jeito de aplicar a mudanca.
  document.querySelectorAll('[data-nt-cart-form]').forEach((form) => {
    const botao = form.querySelector('[data-nt-atualizar]');
    if (botao) botao.hidden = true;
    form.querySelectorAll('[data-nt-qtd]').forEach((campo) => {
      campo.addEventListener('change', () => form.submit());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* O card do Discord. Nasce com [hidden] no HTML de proposito: quem ja fechou
     nao pode ver um piscar antes do JS decidir. Se o JS nao rodar, ele
     simplesmente nao aparece — melhor do que aparecer sem poder ser fechado. */
  const card = document.querySelector('[data-nt-disc]');
  if (card) {
    const CHAVE = 'nt-discord-fechado';
    let fechado = false;
    try { fechado = localStorage.getItem(CHAVE) === '1'; } catch (e) {}
    if (!fechado) card.hidden = false;
    const fechar = card.querySelector('[data-nt-disc-fechar]');
    if (fechar) {
      fechar.addEventListener('click', () => {
        card.hidden = true;
        /* localStorage lanca em navegacao anonima de alguns navegadores. Se
           lancar, o card so volta na proxima visita — bem melhor que um erro
           no console e o clique nao fazendo nada. */
        try { localStorage.setItem(CHAVE, '1'); } catch (e) {}
      });
    }
  }

  /* A BARRA DE COOKIES. Nasce com [hidden] no HTML: quem ja respondeu nao pode
     ver um piscar antes de o JS decidir, e se o JS nao rodar a barra nao
     aparece — melhor do que uma barra que nao da para responder.

     Os botoes chamam a Customer Privacy API da Shopify. E ela que os pixels,
     audiences e o checkout obedecem; sem essa chamada o "Rejeitar" apenas
     esconderia a barra e o rastreamento seguiria igual. */
  /* AVISO DE VENDA. Pergunta de tempos em tempos o que ha de novo e anuncia
     CADA VENDA UMA VEZ SO. Na primeira consulta ele apenas anota qual e a
     compra mais recente e nao mostra nada — essa e a linha de corte. Sem isso,
     quem abrisse o site veria um desfile de compras antigas, que e exatamente
     o que este aviso NAO e.

     A novidade e medida pelo `id` da linha, e nao pela data: duas compras no
     mesmo segundo empatariam e uma sumiria. */
  const prova = document.querySelector('[data-nt-prova]');
  if (prova) {
    const CHAVE_FECHADA = 'nt-prova-fechada';
    const CHAVE_MUDO = 'nt-prova-mudo';
    const numero = (nome, padrao) => {
      const v = parseFloat(prova.dataset[nome]);
      return isFinite(v) && v >= 0 ? v : padrao;
    };
    const duracao = numero('ntProvaVisivel', 30) * 1000;
    const consulta = Math.max(numero('ntProvaConsulta', 20), 5) * 1000;
    const janela = numero('ntProvaJanela', 0) * 60000;
    const mostrarQuando = prova.dataset.ntProvaQuando === 'true';
    const querSom = prova.dataset.ntProvaSom === 'true';

    const alvoNome = prova.querySelector('[data-nt-prova-nome]');
    const alvoProduto = prova.querySelector('[data-nt-prova-produto]');
    const alvoTempo = prova.querySelector('[data-nt-prova-tempo]');
    const alvoFoto = prova.querySelector('[data-nt-prova-foto]');
    const alvoMarca = prova.querySelector('[data-nt-prova-marca]');
    const botaoMudo = prova.querySelector('[data-nt-prova-mudo]');
    const raiz = document.documentElement;

    let imagens = {};
    try {
      const cru = document.querySelector('[data-nt-prova-imagens]');
      if (cru) imagens = JSON.parse(cru.textContent) || {};
    } catch (e) { imagens = {}; }

    let dispensada = false;
    try { dispensada = sessionStorage.getItem(CHAVE_FECHADA) === '1'; } catch (e) {}
    let mudo = false;
    try { mudo = localStorage.getItem(CHAVE_MUDO) === '1'; } catch (e) {}
    if (botaoMudo) botaoMudo.setAttribute('aria-pressed', String(mudo));

    /* ---------------------------------------------------------------- som
       Navegador nenhum toca audio antes de a pessoa tocar na pagina, e nao
       avisa quando bloqueia. O contexto so nasce no primeiro toque ou tecla;
       antes disso a venda aparece calada, e tudo bem.

       O som e sintetizado: dois senos suaves, um quinto acima. Nao ha arquivo
       para hospedar nem carregar, e o volume fica exatamente onde eu escrever. */
    let audio = null;
    const destravarAudio = () => {
      if (audio || !querSom) return;
      try { audio = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) {}
    };
    if (querSom) {
      document.addEventListener('pointerdown', destravarAudio, { once: true, passive: true });
      document.addEventListener('keydown', destravarAudio, { once: true });
    }

    const tocar = () => {
      if (!audio || mudo) return;
      if (audio.state === 'suspended') audio.resume();
      const t0 = audio.currentTime;
      [[587.33, 0], [880, 0.17]].forEach(([hz, atraso]) => {
        const osc = audio.createOscillator();
        const vol = audio.createGain();
        osc.type = 'sine';
        osc.frequency.value = hz;
        /* Rampa exponencial, e nao degrau: som que comeca e termina seco
           estala. Comeca e termina em 0.0001 porque exponencial nao aceita
           zero. Ganho de 0.05 — e para ser notado, nao para assustar. */
        vol.gain.setValueAtTime(0.0001, t0 + atraso);
        vol.gain.exponentialRampToValueAtTime(0.05, t0 + atraso + 0.05);
        vol.gain.exponentialRampToValueAtTime(0.0001, t0 + atraso + 0.9);
        osc.connect(vol).connect(audio.destination);
        osc.start(t0 + atraso);
        osc.stop(t0 + atraso + 1);
      });
    };

    if (botaoMudo) {
      botaoMudo.addEventListener('click', () => {
        mudo = !mudo;
        botaoMudo.setAttribute('aria-pressed', String(mudo));
        try { localStorage.setItem(CHAVE_MUDO, mudo ? '1' : '0'); } catch (e) {}
        /* Clicar ja e interacao: se o som estava travado, destrava agora. */
        destravarAudio();
      });
    }

    prova.querySelector('[data-nt-prova-fechar]').addEventListener('click', () => {
      dispensada = true;
      fila.length = 0;
      esconder();
      try { sessionStorage.setItem(CHAVE_FECHADA, '1'); } catch (e) {}
    });

    /* ------------------------------------------------------------- exibir */
    /* Venda recente NAO ganha linha de tempo. A frase de cima ja diz "acabou
       de comprar"; um "agora mesmo" embaixo contava a mesma coisa de novo, com
       outras palavras. A linha so aparece quando ha distancia de verdade, o que
       hoje so acontece com o setting de janela ligado. */
    const quandoEmPalavras = (iso) => {
      const seg = (Date.now() - new Date(iso).getTime()) / 1000;
      if (!isFinite(seg) || seg < 0) return '';
      if (seg < 120) return '';
      const fmt = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' });
      if (seg < 3600) return fmt.format(-Math.round(seg / 60), 'minute');
      if (seg < 86400) return fmt.format(-Math.round(seg / 3600), 'hour');
      return fmt.format(-Math.round(seg / 86400), 'day');
    };

    function esconder() {
      prova.classList.remove('is-on');
      raiz.classList.remove('nt-prova-na-tela');
      setTimeout(() => { prova.hidden = true; }, 340);
    }

    const fila = [];
    let mostrando = false;
    /* Prazo de validade do que espera na fila. O aviso afirma que a compra
       ACABOU de acontecer; uma que ficou parada quinze minutos esperando a vez
       nao pode mais ser anunciada assim. Acontece quando varias caem juntas, e
       tambem quando a aba fica em segundo plano e o navegador afrouxa os
       temporizadores — a pessoa volta e veria uma fila de vendas velhas se
       anunciando como novas. */
    const VALIDADE = 15 * 60000;

    function bombear() {
      if (mostrando || dispensada) return;
      let c = fila.shift();
      while (c && Date.now() - new Date(c.quando).getTime() > VALIDADE) {
        c = fila.shift();
      }
      if (!c) return;
      mostrando = true;

      alvoNome.textContent = c.nome;
      alvoProduto.textContent = c.produto;
      const texto = mostrarQuando ? quandoEmPalavras(c.quando) : '';
      alvoTempo.textContent = texto;
      alvoTempo.hidden = !texto;

      const foto = imagens[c.produto];
      if (foto) {
        alvoFoto.src = foto;
        alvoFoto.alt = c.produto;
        alvoFoto.hidden = false;
        if (alvoMarca) alvoMarca.hidden = true;
      } else {
        alvoFoto.hidden = true;
        if (alvoMarca) alvoMarca.hidden = false;
      }

      prova.hidden = false;
      /* Uma leitura de layout entre tirar o [hidden] e ligar a classe: sem ela
         o navegador ve os dois estados na mesma passada e nao anima nada. Era
         requestAnimationFrame aninhado, e rAF nao roda em aba de fundo — quem
         abrisse o site numa aba escondida encontraria o card parado 12px abaixo
         do lugar, sem nunca ter aparecido. */
      void prova.offsetWidth;
      prova.classList.add('is-on');
      raiz.classList.add('nt-prova-na-tela');
      tocar();

      setTimeout(() => {
        esconder();
        mostrando = false;
        /* Uma folga entre um aviso e o proximo: duas vendas seguidas trocando
           de texto na mesma caixa parecem defeito, e nao duas vendas. */
        setTimeout(bombear, 900);
      }, duracao);
    }

    /* ----------------------------------------------------------- consultar
       Os tokens que ja passaram por aqui. Antes isto era "o maior id que eu
       vi", e para funcionar a resposta publica precisava carregar o id da
       linha — que e sequencial. Quem consultasse o endereco de tempos em
       tempos veria o contador subir e mediria o volume e o ritmo de vendas da
       loja. Guardando IDENTIDADE em vez de ORDEM, o endereco publico nao conta
       mais nada sobre quantidade, e o aviso funciona igual. */
    const vistos = new Set();
    let primeira = true;

    function consultar() {
      return fetch(prova.dataset.ntProvaUrl, { headers: { accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status))))
        .then((dados) => {
          /* Vem da mais nova para a mais velha; anunciar na ordem em que
             aconteceram. */
          const compras = ((dados && dados.compras) || [])
            .filter((c) => c && c.token && c.nome && c.produto)
            .reverse();

          const novas = compras.filter((c) => !vistos.has(c.token));
          novas.forEach((c) => vistos.add(c.token));

          if (primeira) {
            /* A LINHA DE CORTE. Na chegada da pessoa nada e anunciado: o que
               aconteceu antes dela chegar nao e novidade para ela. Sem isto o
               aviso viraria um desfile de compras antigas, que e exatamente o
               que ele deixou de ser.

               Marcada ANTES de qualquer saida antecipada, inclusive quando a
               resposta vem vazia. Antes havia um `if (!compras.length) return`
               aqui em cima e a linha de corte nunca era marcada num periodo sem
               venda nenhuma — a PRIMEIRA venda a chegar seria engolida como se
               fosse o corte, e ninguem veria o aviso dela. */
            primeira = false;
            if (janela > 0 && novas.length) {
              const corte = Date.now() - janela;
              novas
                .filter((c) => new Date(c.quando).getTime() >= corte)
                .forEach((c) => fila.push(c));
              bombear();
            }
            return;
          }

          if (!novas.length) return;
          novas.forEach((c) => fila.push(c));
          bombear();
        })
        .catch((e) => {
          /* O aviso e enfeite: se a funcao estiver fora do ar o site segue
             igual. Vai para o console para nao virar defeito invisivel. */
          console.warn('[nt] aviso de venda indisponivel', e);
        });
    }

    if (!dispensada) {
      consultar();
      setInterval(consultar, consulta);
    }
  }

  const cookies = document.querySelector('[data-nt-cook]');
  if (cookies) {
    const CHAVE = 'nt-cookies';
    const painel = cookies.querySelector('[data-nt-cook-painel]');
    const maisBtn = cookies.querySelector('[data-nt-cook-personalizar]');
    const analise = cookies.querySelector('[data-nt-cook-analise]');
    const marketing = cookies.querySelector('[data-nt-cook-marketing]');

    /* A API vem sob demanda. Se nao carregar, a escolha ainda fica gravada aqui
       e a barra some, mas isso e uma falha de verdade — vai para o console em
       vez de passar silenciosamente por consentimento aplicado. */
    let privacidade = null;
    try {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (erro) => {
          if (erro) {
            console.warn('[nt] consent-tracking-api nao carregou; a escolha de cookies nao chegara aos pixels', erro);
            return;
          }
          privacidade = window.Shopify.customerPrivacy;
        }
      );
    } catch (e) {
      console.warn('[nt] window.Shopify indisponivel; a escolha de cookies nao chegara aos pixels', e);
    }

    const responder = (escolha) => {
      if (privacidade) privacidade.setTrackingConsent(escolha, () => {});
      try { localStorage.setItem(CHAVE, JSON.stringify(escolha)); } catch (e) {}
      cookies.hidden = true;
      document.documentElement.classList.remove('nt-cookies-abertas');
    };

    cookies.querySelector('[data-nt-cook-tudo]').addEventListener('click', () => {
      responder({ analytics: true, marketing: true, preferences: true, sale_of_data: true });
    });
    cookies.querySelector('[data-nt-cook-nao]').addEventListener('click', () => {
      responder({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
    });
    /* sale_of_data fica false na escolha detalhada: o visitante marcou duas
       caixas, e nenhuma delas falava em venda de dados. */
    cookies.querySelector('[data-nt-cook-salvar]').addEventListener('click', () => {
      responder({
        analytics: analise.checked,
        marketing: marketing.checked,
        preferences: true,
        sale_of_data: false
      });
    });
    maisBtn.addEventListener('click', () => {
      const abrir = painel.hidden;
      painel.hidden = !abrir;
      maisBtn.setAttribute('aria-expanded', String(abrir));
    });

    let respondido = false;
    try { respondido = !!localStorage.getItem(CHAVE); } catch (e) {}
    /* Se a Shopify estiver servindo o aviso nativo dela, o nosso se cala: dois
       avisos de cookies na mesma tela e pior do que nenhum.
       ponytail: a checagem e sincrona e o aviso nativo pode ser injetado
       depois. Hoje a loja nao tem nenhum — conferido, zero ocorrencia de
       consent no tema. Se um dia aparecer, o interruptor no editor desliga. */
    const nativo = document.getElementById('shopify-pc__banner') || window.privacyBanner;
    if (!respondido && !nativo) {
      cookies.hidden = false;
      document.documentElement.classList.add('nt-cookies-abertas');
    }
  }

  const subir = document.querySelector('[data-nt-top]');
  if (subir) {
    const GATILHO = 600;
    const conferir = () => subir.classList.toggle('is-on', window.scrollY > GATILHO);
    conferir();
    window.addEventListener('scroll', conferir, { passive: true });
    subir.addEventListener('click', () => {
      const parado = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: parado ? 'auto' : 'smooth' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* AS DUAS LINHAS DO TITULO TERMINAM NO MESMO PONTO.

     Nao da para fazer isto so com CSS: as duas frases tem contagens de letra
     diferentes, entao no mesmo tamanho de fonte uma sempre passa da outra. Aqui
     "se limitar apenas as suas maos" e 2,4% mais larga que "a realidade virtual
     nao deve", e era esse o degrau que aparecia na tela.

     A conta e uma regra de tres. Mede-se cada linha uma vez com nowrap para
     saber quantos pixels ela custa por pixel de fonte; a linha MAIS LARGA vira a
     medida do bloco e fica com o tamanho que o CSS ja lhe deu; as outras
     recebem medida dividida pelo proprio custo. So se AUMENTA fonte, nunca se
     diminui, entao nada estoura a coluna.

     Essa mesma medida vai para --nt-hero-medida, e e ela que faz o apoio e os
     tres pontos pararem onde o titulo para.

     Roda depois de document.fonts.ready porque a medida de uma linha depende da
     fonte que a desenha: medida com a fonte de reserva, a conta sai errada e o
     ajuste fica visivelmente torto quando a GeBody chega. */
  (function () {
    function ajustar(titulo) {
      var linhas = titulo.querySelectorAll('.nt-hero__linha');
      var coluna = titulo.closest('.nt-hero__texto');
      if (!linhas.length || !coluna) return;

      // Empilhadas? Abaixo de 640px elas correm como um paragrafo so, e a
      // medida por linha nao quer dizer nada.
      if (getComputedStyle(linhas[0]).display !== 'block') {
        linhas.forEach(function (l) { l.style.fontSize = ''; });
        coluna.style.removeProperty('--nt-hero-medida');
        return;
      }

      var base = parseFloat(getComputedStyle(titulo).fontSize);
      var custos = [];
      linhas.forEach(function (l) {
        l.style.fontSize = '';
        var antes = l.style.whiteSpace;
        l.style.whiteSpace = 'nowrap';
        // A caixa e um bloco e ocupa a coluna toda, entao quem mede o texto e o
        // Range e nao o retangulo do elemento.
        var faixa = document.createRange();
        faixa.selectNodeContents(l);
        custos.push(faixa.getBoundingClientRect().width / base);
        l.style.whiteSpace = antes;
      });

      var medida = Math.max.apply(null, custos) * base;
      linhas.forEach(function (l, i) {
        l.style.fontSize = (medida / custos[i]).toFixed(2) + 'px';
      });
      coluna.style.setProperty('--nt-hero-medida', Math.round(medida) + 'px');
    }

    function todos() {
      document.querySelectorAll('.nt-hero__titulo').forEach(ajustar);
    }

    function iniciar() {
      todos();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(todos);
      var espera;
      addEventListener('resize', function () {
        clearTimeout(espera);
        espera = setTimeout(todos, 150);
      });
      // O editor de temas remonta a secao ao vivo, e a nova nasce sem o ajuste.
      document.addEventListener('shopify:section:load', todos);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-market-compare"] && !Shopify.designMode) return;
  try {
    
  // Converte o preco das colunas importadas pelo dolar de hoje.
  //
  // Este bloco NAO passa pelo Liquid: o que vem da loja chega por
  // data-atributo no markup.
  //
  // POR QUE SO O CAMBIO E AO VIVO. O preco de origem em dolar e o imposto sao
  // ajustes: mudam quando o concorrente mexe na tabela dele, o que e raro e o
  // dono acompanha. O cambio muda todo dia, e era ele que fazia o numero em
  // real envelhecer sozinho entre uma visita e outra.
  //
  // Buscar o preco do concorrente em tempo real seria raspar o site dele: quebra
  // na primeira mudanca de layout, e nenhum deles publica uma API.
  (function () {
    'use strict';

    var HORA = 60 * 60 * 1000;
    var CHAVE = 'nt-usd-brl';

    function guardada() {
      try {
        var bruto = sessionStorage.getItem(CHAVE);
        if (!bruto) return null;
        var d = JSON.parse(bruto);
        return Date.now() - d.em < HORA ? d.taxa : null;
      } catch (e) { return null; }
    }

    function guardar(taxa) {
      try { sessionStorage.setItem(CHAVE, JSON.stringify({ taxa: taxa, em: Date.now() })); } catch (e) {}
    }

    async function cotacao() {
      var salva = guardada();
      if (salva) return salva;
      var r = await fetch('https://economia.awesomeapi.com.br/json/last/USD-BRL');
      if (!r.ok) throw new Error('HTTP ' + r.status);
      var j = await r.json();
      var taxa = parseFloat(j.USDBRL && j.USDBRL.bid);
      if (!(taxa > 0)) throw new Error('sem cotacao');
      guardar(taxa);
      return taxa;
    }

    async function converter(secao) {
      var celulas = secao.querySelectorAll('[data-nt-usd]');
      if (!celulas.length) return;

      var taxa = await cotacao();
      var imposto = 1 + (Number(secao.dataset.ntImposto) || 0) / 100;
      var real = new Intl.NumberFormat('pt-BR', {
        style: 'currency', currency: 'BRL', maximumFractionDigits: 0
      });

      celulas.forEach(function (celula) {
        var usd = Number(celula.dataset.ntUsd);
        if (!(usd > 0)) return;
        var alvo = celula.querySelector('[data-nt-preco]');
        if (!alvo) return;
        // Arredonda para a dezena de cima: e preco de referencia, e centavo
        // num numero que muda todo dia finge uma precisao que ele nao tem.
        var brl = Math.ceil(usd * imposto * taxa / 10) * 10;
        alvo.textContent = (secao.dataset.ntPrefixo || '') + real.format(brl);
      });

      var nota = secao.querySelector('[data-nt-cotacao]');
      if (nota) {
        nota.textContent = ' ' + (secao.dataset.ntNotaCotacao || 'Dolar de hoje:') + ' ' +
          new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(taxa) + '.';
        nota.hidden = false;
      }
    }

    function ligar() {
      document.querySelectorAll('.nt-mc[data-nt-imposto]').forEach(function (secao) {
        // Falhou a consulta, fica o valor escrito a mao que ja esta na tela.
        converter(secao).catch(function () {});
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ligar, { once: true });
    } else {
      ligar();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-products"] && !Shopify.designMode) return;
  try {
    
  const semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Carrossel com arraste de ponteiro. Toque nao entra: la o scroll nativo
     ja faz o trabalho e interceptar so atrapalha. */
  if (!customElements.get('nt-drag')) {
    customElements.define('nt-drag', class extends HTMLElement {
      connectedCallback() {
        this.pointerId = null;
        this.startX = 0;
        this.startScroll = 0;
        this.moved = false;

        this.addEventListener('pointerdown', this.onDown.bind(this));
        this.addEventListener('pointermove', this.onMove.bind(this));
        this.addEventListener('pointerup', this.onUp.bind(this));
        this.addEventListener('pointercancel', this.onUp.bind(this));

        // Um arraste nao pode virar clique no link do card.
        this.addEventListener('click', (evento) => {
          if (!this.moved) return;
          evento.preventDefault();
          evento.stopPropagation();
          this.moved = false;
        }, true);
        this.addEventListener('dragstart', (e) => e.preventDefault());

        const nav = this.parentElement && this.parentElement.querySelector('.nt-products__nav');
        if (nav) {
          const prev = nav.querySelector('[data-nt-prev]');
          const next = nav.querySelector('[data-nt-next]');
          if (prev) prev.addEventListener('click', () => this.step(-1));
          if (next) next.addEventListener('click', () => this.step(1));
          this.nav = { prev, next };
          this.sync = this.sync.bind(this);
          this.addEventListener('scroll', this.sync, { passive: true });
          window.addEventListener('resize', this.sync);
          this.sync();
        }
      }

      disconnectedCallback() {
        if (this.sync) window.removeEventListener('resize', this.sync);
      }

      onDown(evento) {
        if (evento.pointerType === 'touch') return;
        this.pointerId = evento.pointerId;
        this.startX = evento.clientX;
        this.startScroll = this.scrollLeft;
        this.moved = false;
        this.classList.add('is-dragging');
      }

      onMove(evento) {
        if (this.pointerId !== evento.pointerId) return;
        const dx = evento.clientX - this.startX;
        if (Math.abs(dx) > 6) {
          this.moved = true;
          if (!this.hasPointerCapture(evento.pointerId)) this.setPointerCapture(evento.pointerId);
        }
        if (!this.moved) return;
        this.scrollLeft = this.startScroll - dx;
      }

      onUp(evento) {
        if (this.pointerId !== evento.pointerId) return;
        if (this.hasPointerCapture(evento.pointerId)) this.releasePointerCapture(evento.pointerId);
        this.pointerId = null;
        this.classList.remove('is-dragging');
      }

      step(dir) {
        const card = this.querySelector('[data-nt-card]');
        const gap = parseFloat(getComputedStyle(this).columnGap) || 24;
        const passo = card ? card.offsetWidth + gap : this.clientWidth * 0.8;
        this.scrollBy({ left: dir * passo, behavior: semMovimento ? 'auto' : 'smooth' });
      }

      sync() {
        if (!this.nav) return;
        if (this.nav.prev) this.nav.prev.disabled = this.scrollLeft <= 4;
        if (this.nav.next) {
          this.nav.next.disabled = this.scrollLeft + this.clientWidth >= this.scrollWidth - 4;
        }
      }
    });
  }

  /* Filtro de categoria. Esconde e mostra os cards no proprio lugar, sem
     navegar. Sem JS os chips nao fazem nada e todos os produtos continuam
     visiveis, que e o estado correto. */
  function ligarFiltros(raiz) {
    (raiz || document).querySelectorAll('.nt-products').forEach((secao) => {
      const chips = secao.querySelectorAll('[data-nt-chip]');
      const rail = secao.querySelector('[data-nt-rail]');
      if (!chips.length || !rail) return;

      // A altura do carrossel cheio vira piso da mensagem de vazio, para a
      // secao nao encolher e crescer a cada troca de categoria. Medida, e nao
      // fixada no CSS: depende do texto e da foto de cada card.
      const nav = secao.querySelector('.nt-products__nav');
      const medir = () => {
        if (secao.classList.contains('is-empty')) return;
        const topo = rail.getBoundingClientRect().top;
        const base = (nav || rail).getBoundingClientRect().bottom;
        // As margens de fora ficam de fora do getBoundingClientRect, e a
        // mensagem de vazio nao as tem: sem somar, a secao encolhia
        // exatamente o tanto da margem acima do carrossel.
        const estilo = getComputedStyle(rail);
        let margens = (parseFloat(estilo.marginTop) || 0) + (parseFloat(estilo.marginBottom) || 0);
        if (nav) margens += parseFloat(getComputedStyle(nav).marginBottom) || 0;
        const altura = Math.round(base - topo + margens);
        if (altura > 0) secao.style.setProperty('--nt-products-min', altura + 'px');
      };
      medir();
      window.addEventListener('load', medir);

      const aplicar = (chip, rolar) => {
        chips.forEach((outro) => {
          const on = outro === chip;
          outro.classList.toggle('is-active', on);
          outro.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        const bruto = (chip.getAttribute('data-nt-match') || '').trim();
        const termos = bruto ? bruto.split(',').map((t) => t.trim()).filter(Boolean) : [];

        let visiveis = 0;
        rail.querySelectorAll('[data-nt-card]').forEach((card) => {
          const palheiro = card.getAttribute('data-nt-terms') || '';
          const casa = termos.length === 0 || termos.some((t) => palheiro.indexOf(t) !== -1);
          card.hidden = !casa;
          if (casa) visiveis += 1;
        });

        secao.classList.toggle('is-empty', visiveis === 0);
        rail.scrollTo({ left: 0, behavior: 'auto' });
        if (rail.sync) rail.sync();
        if (rolar) {
          secao.scrollIntoView({ behavior: semMovimento ? 'auto' : 'smooth', block: 'start' });
        }
      };

      chips.forEach((chip) => chip.addEventListener('click', () => aplicar(chip, false)));

      // Categoria vinda da URL: e o que faz o mega menu abrir a pagina de
      // produtos ja filtrada. O apelido de cada chip esta em data-nt-slug.
      let pedido = null;
      try {
        pedido = new URLSearchParams(window.location.search).get('categoria');
      } catch (e) {
        pedido = null;
      }
      if (!pedido) return;
      pedido = pedido.trim().toLowerCase();
      for (const chip of chips) {
        if ((chip.getAttribute('data-nt-slug') || '').toLowerCase() === pedido) {
          aplicar(chip, true);
          break;
        }
      }
    });
  }

  ligarFiltros(document);
  document.addEventListener('shopify:section:load', (evento) => ligarFiltros(evento.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Leitor da avaliacao inteira. Copia do cartao para a folha no clique, para
     nao ter 51 dialogos parados no DOM. */
  (function () {
    function ligar(raiz) {
      var folha = raiz.querySelector('[data-nt-leitor]');
      if (!folha || folha.dataset.ligado) return;
      folha.dataset.ligado = '1';

      var nome = folha.querySelector('[data-nt-leitor-nome]');
      var data = folha.querySelector('[data-nt-leitor-data]');
      var estrelas = folha.querySelector('[data-nt-leitor-estrelas]');
      var titulo = folha.querySelector('[data-nt-leitor-titulo]');
      var texto = folha.querySelector('[data-nt-leitor-texto]');

      var painel = folha.querySelector('[data-nt-leitor-midia]');
      var quadro = folha.querySelector('[data-nt-leitor-quadro]');
      var btExpandir = folha.querySelector('[data-nt-leitor-expandir]');
      var btMidiaNext = folha.querySelector('[data-nt-leitor-midia-next]');
      var contaMidia = folha.querySelector('[data-nt-leitor-midia-conta]');
      var barraMidia = folha.querySelector('[data-nt-leitor-midia-barra]');
      var btPrev = folha.querySelector('[data-nt-leitor-prev]');
      var btNext = folha.querySelector('[data-nt-leitor-next]');
      var contaRev = folha.querySelector('[data-nt-leitor-conta]');

      /* O estado do leitor. `midias` sai do catalogo que o proprio cartao ja
         emite em <script data-nt-media> — o mesmo que o lightbox consome. Ler
         dali em vez de remontar URLs evita ter duas verdades sobre a midia de
         uma avaliacao. */
      var atual = null;
      var midias = [];
      var iMidia = 0;

      /* Andar entre avaliacoes passa por TODAS, e nao so pelas tres da pagina
         aberta: parar na terceira transformava o leitor numa amostra em vez de
         uma leitura.

         A grade atras acompanha. Antes eu tinha limitado a navegacao as
         visiveis justamente para nao dessincronizar as duas; a resposta certa
         nao era limitar, era virar a pagina junto. Assim fechar o leitor cai
         na pagina onde a pessoa parou.

         Cartao com data-nt-fora esta filtrado por uma aba e continua de fora:
         ele nao aparece nem na grade nem na contagem. */
      var grade = raiz.querySelector('nt-reviews');

      function todosCartoes() {
        if (grade && grade.cards) return grade.cards;
        return Array.prototype.filter.call(
          raiz.querySelectorAll('[data-nt-review]'),
          function (c) { return !c.dataset.ntFora; }
        );
      }

      /* Leva a grade para a pagina onde o cartao mora. Sem isto o leitor
         avanca e a grade atras fica parada, e o "3 de 65" do rodape nao
         corresponde a nada do que se ve ao fechar. */
      function sincronizarPagina(card) {
        if (!grade || !grade.cards || !grade.size || !grade.to) return;
        var i = grade.cards.indexOf(card);
        if (i < 0) return;
        var pagina = Math.floor(i / grade.size);
        if (pagina !== grade.page) grade.to(pagina);
      }

      function lerCatalogo(card) {
        var tag = card.querySelector('script[data-nt-media]');
        if (!tag) return [];
        try { return JSON.parse(tag.textContent) || []; } catch (erro) { return []; }
      }

      function pintarMidia() {
        quadro.textContent = '';

        /* A CAIXA DA MIDIA NAO SOME MAIS.

           Antes ela desaparecia quando a avaliacao nao tinha foto, e o arranjo
           mudava junto: andando de uma avaliacao para a outra, a caixa do
           texto pulava de lugar toda vez que a vizinha tinha ou nao tinha
           imagem. Com as duas sempre na tela e do mesmo tamanho, o arranjo
           fica parado e so o conteudo muda.

           Sem foto ela diz isso, no centro. Caixa vazia sem explicacao parece
           imagem que nao carregou. */
        var vazio = !midias.length;
        painel.hidden = false;
        barraMidia.hidden = vazio;
        if (vazio) {
          var aviso = document.createElement('p');
          aviso.className = 'nt-rev__quadro-vazio';
          aviso.textContent = painel.dataset.ntSemMidiaLabel || 'Avaliação sem imagem';
          quadro.appendChild(aviso);
          return;
        }

        var item = midias[iMidia];

        if (item.kind === 'image') {
          var img = document.createElement('img');
          img.className = 'nt-rev__quadro-media';
          img.src = item.src;
          img.alt = '';
          img.loading = 'lazy';
          quadro.appendChild(img);
        } else {
          /* Video, da loja ou do YouTube: capa mais botao. O player so entra no
             DOM no clique, que e o mesmo acordo do resto do site. Sem isso,
             abrir uma avaliacao carregaria script e cookie de terceiro sem
             ninguem ter pedido video nenhum. */
          var capa = document.createElement('img');
          capa.className = 'nt-rev__quadro-media';
          capa.alt = '';
          capa.loading = 'lazy';
          capa.src = item.kind === 'youtube'
            ? 'https://i.ytimg.com/vi/' + item.id + '/hqdefault.jpg'
            : (item.poster || '');
          quadro.appendChild(capa);

          var play = document.createElement('button');
          play.type = 'button';
          play.className = 'nt-rev__quadro-play';
          /* O rotulo vem do atributo porque o bloco de script nao renderiza
             Liquid: escrito la dentro, ele sairia literal na pagina. */
          play.textContent = painel.dataset.ntPlayLabel || 'Ver vídeo';
          play.addEventListener('click', function () {
            quadro.textContent = '';
            if (item.kind === 'youtube') {
              var yt = document.createElement('iframe');
              yt.className = 'nt-rev__quadro-media';
              yt.src = 'https://www.youtube.com/embed/' + encodeURIComponent(item.id) +
                       '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
              yt.title = 'YouTube';
              yt.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
              yt.allowFullscreen = true;
              yt.setAttribute('frameborder', '0');
              quadro.appendChild(yt);
            } else {
              var v = document.createElement('video');
              v.className = 'nt-rev__quadro-media';
              v.src = item.src;
              if (item.poster) v.poster = item.poster;
              v.controls = true;
              v.autoplay = true;
              v.playsInline = true;
              quadro.appendChild(v);
            }
          });
          quadro.appendChild(play);
        }

        var varias = midias.length > 1;
        btMidiaNext.hidden = !varias;
        contaMidia.hidden = !varias;
        if (varias) contaMidia.textContent = (iMidia + 1) + '/' + midias.length;
      }

      function abrir(card) {
        atual = card;
        var botao = card.querySelector('[data-nt-ler]');

        nome.textContent = (botao && botao.dataset.ntNome) || '';
        data.textContent = (botao && botao.dataset.ntData) || '';
        data.hidden = !(botao && botao.dataset.ntData);

        var fonte = card.querySelector('.nt-stars');
        estrelas.innerHTML = '';
        if (fonte) estrelas.appendChild(fonte.cloneNode(true));

        var t = card.querySelector('.nt-rev__cardtitle');
        titulo.textContent = t ? t.textContent : '';
        titulo.hidden = !t;

        var corpo = card.querySelector('.nt-rev__body');
        texto.innerHTML = corpo ? corpo.innerHTML : '';
        texto.scrollTop = 0;

        midias = lerCatalogo(card);
        iMidia = 0;
        pintarMidia();

        sincronizarPagina(card);

        var lista = todosCartoes();
        var pos = Array.prototype.indexOf.call(lista, card);
        contaRev.textContent = pos >= 0 ? (pos + 1) + ' de ' + lista.length : '';
        btPrev.disabled = pos <= 0;
        btNext.disabled = pos < 0 || pos >= lista.length - 1;
      }

      raiz.addEventListener('click', function (e) {
        var botao = e.target.closest('[data-nt-ler]');
        if (!botao) return;
        var card = botao.closest('[data-nt-review]');
        if (!card) return;
        abrir(card);
        folha.showModal();
      });

      btMidiaNext.addEventListener('click', function () {
        if (!midias.length) return;
        iMidia = (iMidia + 1) % midias.length;
        pintarMidia();
      });

      /* Expandir devolve o catalogo ao lightbox que ja existe, no indice em que
         a pessoa estava. Um visualizador proprio aqui seria a segunda
         implementacao do mesmo zoom, e as duas divergiriam.

         O leitor se fecha para dar lugar ao lightbox, porque um elemento fixo
         nao pinta acima de um dialogo em camada superior. Guardar de onde saiu
         e o que permite VOLTAR: sem isto, fechar a foto largava a pessoa na
         pagina em vez de devolver a avaliacao que ela estava lendo. */
      var voltarPara = null;

      function quieto() {
        return window.matchMedia &&
               window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      /* FLIP. A peca ja esta no lugar final quando isto roda; o que se anima e
         o caminho de VOLTA ate onde ela estava, invertido pelo tempo. Medir o
         destino de verdade em vez de estimar para onde ela vai e o que faz a
         animacao terminar exatamente no layout, sem salto no ultimo quadro.

         `transform-origin` no canto superior esquerdo porque a conta de
         translate mais scale so fecha a partir dali: com a origem no centro, o
         deslocamento teria de compensar a metade da diferenca de tamanho. */
      function crescerDe(peca, de) {
        if (!peca || !de || !de.width || quieto() || !peca.animate) return;
        var para = peca.getBoundingClientRect();
        if (!para.width || !para.height) return;
        peca.animate(
          [
            {
              transformOrigin: 'top left',
              transform: 'translate(' + (de.left - para.left) + 'px, ' +
                         (de.top - para.top) + 'px) scale(' +
                         (de.width / para.width) + ', ' +
                         (de.height / para.height) + ')',
              opacity: 0.55
            },
            { transformOrigin: 'top left', transform: 'none', opacity: 1 }
          ],
          { duration: 320, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }
        );
      }

      function expandir() {
        if (!midias.length || !atual) return;
        var alvo = atual.querySelector('[data-nt-open-media]');
        if (!alvo) return;

        /* De onde a foto sai, medido enquanto o leitor ainda esta aberto. */
        var origem = quadro.querySelector('.nt-rev__quadro-media');
        var de = null;
        if (origem) {
          var r = origem.getBoundingClientRect();
          de = { left: r.left, top: r.top, width: r.width, height: r.height };
        }

        voltarPara = { card: atual, midia: iMidia };
        folha.close();
        alvo.dataset.ntOpenMedia = String(iMidia);
        alvo.click();

        var lb = document.querySelector('nt-lightbox');
        var peca = lb && lb.querySelector('.nt-lb__media');
        /* Imagem ainda sem tamanho e imagem que nao carregou: medir agora daria
           zero e a animacao sairia de um ponto. A fonte e a mesma do quadro, e
           por isso quase sempre ja esta em cache — o `load` e a rede. */
        if (peca && peca.tagName === 'IMG' && !peca.complete) {
          peca.addEventListener('load', function () { crescerDe(peca, de); }, { once: true });
        } else {
          crescerDe(peca, de);
        }
      }

      btExpandir.addEventListener('click', expandir);

      /* Clicar NA FOTO faz o mesmo que o botao: e o gesto que a pessoa tenta
         primeiro. Vale so para imagem — em video o clique e do play, que cobre
         o quadro inteiro e trata o proprio evento. */
      quadro.addEventListener('click', function (e) {
        if (e.target.tagName !== 'IMG') return;
        if (quadro.querySelector('.nt-rev__quadro-play')) return;
        expandir();
      });

      document.addEventListener('nt-lb-fechou', function (e) {
        if (!voltarPara) return;
        var volta = voltarPara;
        voltarPara = null;
        var de = e.detail && e.detail.de;
        abrir(volta.card);
        /* Volta na MESMA midia que estava sendo vista. Reabrir na primeira
           faria a pessoa procurar de novo onde estava. */
        if (volta.midia < midias.length) {
          iMidia = volta.midia;
          pintarMidia();
        }
        folha.showModal();
        /* E encolhe de volta para o quadro, pelo mesmo caminho. Sem isto a
           ida seria suave e a volta um corte seco, o que faz o movimento
           parecer defeito em vez de intencao. */
        crescerDe(quadro.querySelector('.nt-rev__quadro-media'), de);
      });

      function andar(passo) {
        var lista = todosCartoes();
        var pos = Array.prototype.indexOf.call(lista, atual);
        var destino = lista[pos + passo];
        if (destino) abrir(destino);
      }
      btPrev.addEventListener('click', function () { andar(-1); });
      btNext.addEventListener('click', function () { andar(1); });

      folha.querySelector('[data-nt-leitor-fechar]').addEventListener('click', function () {
        /* Fechar de proposito desarma o retorno. Sem isto, abrir uma foto,
           fechar o leitor e depois abrir qualquer outra midia da pagina faria
           o leitor ressurgir sozinho. */
        voltarPara = null;
        folha.close();
      });
      /* Clique no fundo fecha: o ::backdrop e alvo do proprio dialog. */
      folha.addEventListener('click', function (e) {
        if (e.target === folha) folha.close();
      });
    }

    /* Quantas linhas cabem. Porte de MobileMediaReviewText
       (ReviewsApple.tsx:239-252): mede a caixa, divide pelo line-height, usa o
       piso, e refaz quando a caixa muda. A caixa e flex: 1 com min-height: 0,
       entao a altura dela vem do cartao e nao do texto — por isso clampear nao
       muda a medida e nao ha laco. */
    function medir(caixa) {
      var texto = caixa.querySelector('.nt-rev__body');
      if (!texto) return;

      /* Cartao escondido pela paginacao mede zero, e zero dividido pelo
         line-height daria clamp de 1 linha — o texto sumia do cartao quando
         ele voltasse a aparecer. O original nunca cai nisso porque la o
         cartao escondido nem existe no DOM. */
      if (!caixa.clientHeight) return;

      var lh = parseFloat(getComputedStyle(texto).lineHeight);
      if (!isFinite(lh) || lh <= 0) return;
      var linhas = Math.max(1, Math.floor(caixa.clientHeight / lh));
      if (texto.style.getPropertyValue('--nt-rev-linhas') !== String(linhas)) {
        texto.style.setProperty('--nt-rev-linhas', linhas);
      }

      /* A caixa encolhe para um numero INTEIRO de linhas. Sem isto ela fica com
         a sobra que nao completa uma linha, e essa sobra deixava aparecer meia
         linha recortada embaixo do texto quando o clamp, por qualquer motivo,
         nao pegava. Com a caixa medindo exatamente linhas x entrelinha, o que
         for recortado e recortado na fronteira da linha. */
      var altura = linhas * lh;
      if (caixa.style.maxHeight !== altura + 'px') {
        caixa.style.maxHeight = altura + 'px';
      }

      /* O botao so aparece se o texto REALMENTE foi cortado. Antes isso era
         estimado por contagem de caracteres, com os limites 220 e 460 do
         original — numeros calibrados para o cartao do celular, que tem outra
         largura e outra altura. Aqui a pergunta e respondida pela medida: com
         o clamp aplicado, o paragrafo rola dentro de si mesmo quando sobra
         texto. E o paragrafo, nao a caixa: a caixa e irma de altura fixa e a
         conta daria sempre verdadeiro. */
      var botao = caixa.parentElement && caixa.parentElement.querySelector('[data-nt-ler]');
      if (botao) botao.hidden = texto.scrollHeight <= texto.clientHeight + 1;
    }

    var observador = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(function (entradas) {
          entradas.forEach(function (e) { medir(e.target); });
        })
      : null;

    function medirTodas(raiz) {
      (raiz || document).querySelectorAll('.nt-rev__card .nt-rev__scroll').forEach(function (caixa) {
        medir(caixa);
        if (observador && !caixa.dataset.medindo) {
          caixa.dataset.medindo = '1';
          observador.observe(caixa);
        }
      });
    }

    medirTodas(document);
    /* Remede quando a fonte da marca chega. Nao e pelo line-height: ele e
       numerico, 1.6, e nao muda com a troca de fonte. E porque o TITULO do
       cartao pode passar de uma para duas linhas quando a fonte chega, e ai a
       caixa do texto encolhe. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { medirTodas(document); });
    }

    /* E remede depois que a pagina inteira carregou.

       A altura da caixa vem da linha da grade, e a linha so tem altura final
       quando as fotos dos cartoes chegam. Este script roda durante a analise
       do documento, entao a primeira passada media zero e desistia, e nem
       fonts.ready resolvia: ele dispara antes das imagens. Na loja o efeito
       era o cartao do Bryan com o texto cortado em seis linhas e sem o botao
       de ler completa, enquanto a caixa dele media 260. */
    if (document.readyState === 'complete') {
      medirTodas(document);
    } else {
      window.addEventListener('load', function () { medirTodas(document); });
    }
    window.addEventListener('resize', function () { medirTodas(document); });

    /* Toda vez que a grade troca o que esta na tela, remede.

       O ouvinte antigo espiava CLIQUE no paginador, e por isso perdia os dois
       momentos que mais importam: a primeira renderizacao, que a propria
       grade faz ao subir, e a reordenacao por data, que troca quem esta na
       pagina zero sem clique nenhum. O efeito era cartao com o texto cortado
       em seis linhas e SEM o botao de ler completa: a medida que decide as
       duas coisas nunca tinha rodado naquele cartao.

       O ResizeObserver deveria cobrir isso sozinho, porque a caixa vai de zero
       para a altura real. Depender so dele e depender de quando o navegador
       resolve entregar o callback, e em aba de segundo plano ele nao entrega. */
    document.addEventListener('nt-rev-render', function (e) {
      var secao = e.target.closest('.nt-rev');
      if (secao) medirTodas(secao);
    });

    /* Abas. Escondem os cartões da outra origem e mandam a paginação recontar
       — sem isso ela continuaria paginando a lista inteira e mostraria página
       vazia. O reset() é do <nt-reviews>, em nt-sections.js. */
    function ligarAbas(raiz) {
      var barra = raiz.querySelector('[data-nt-aba]');
      if (!barra) return;
      var grade = raiz.querySelector('nt-reviews');
      raiz.querySelectorAll('[data-nt-aba]').forEach(function (aba) {
        aba.addEventListener('click', function () {
          var alvo = aba.dataset.ntAba;
          raiz.querySelectorAll('[data-nt-aba]').forEach(function (outra) {
            var on = outra === aba;
            outra.classList.toggle('is-active', on);
            outra.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          raiz.querySelectorAll('[data-nt-review]').forEach(function (card) {
            card.dataset.ntFora = card.dataset.ntOrigem === alvo ? '' : '1';
          });
          if (grade && grade.reset) grade.reset();
          medirTodas(raiz);
        });
      });
      /* Estado inicial: a aba de produto ja nasce ativa no markup. */
      raiz.querySelectorAll('[data-nt-review]').forEach(function (card) {
        card.dataset.ntFora = card.dataset.ntOrigem === 'produto' ? '' : '1';
      });
      if (grade && grade.reset) grade.reset();
    }

    document.querySelectorAll('.nt-rev').forEach(function (raiz) {
      ligar(raiz);
      ligarAbas(raiz);
    });
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.nt-rev').forEach(function (raiz) {
        ligar(raiz);
        ligarAbas(raiz);
      });
      medirTodas(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
